import _ from 'lodash'
import update from 'react-addons-update'
import moment from 'moment'
import 'moment-range'
import { getObjVal, getRoomDisplayName, isEmpty } from '../utils'
import { roomDisplaySortOrder } from '../constants/roomConstants'
import * as actions from '../redux/actions'
import { isAdultRequired } from '../logic/roomLogic'
import history from '../history'

// export function removeExtraSelections (selections, removeEmptySels = true) {
//   let ret = _.chain(selections)
//   if (removeEmptySels) {
//     ret = ret.filter(sel => sel.numRooms > 0)
//   }
//   return ret.map(sel => {
//     return {
//       ...sel,
//       rooms: sel.rooms.slice(0, sel.numRooms).map((room, index) => {
//         return {
//           ...room,
//           guestInfoList: room.guestInfoList.slice(0, sel.guests[index])
//         }
//       })
//     }
//   })
//   .value()
// }

export function updateCollection(data, changes) {
  if (!_.isArray(changes)) {
    changes = [changes]
  }

  let updates = _.transform(
    changes,
    (result, change) => {
      result[change.id] = _(change)
        .omit('id')
        .mapValues(value => ({ $set: value }))
        .value()
    },
    {}
  )

  return update(data, updates)
}

// Validates the given room. If it doesn't expected adult/children pair then it throws the error message.
export function getInvalidRoom(
  authenticated,
  room,
  guestInfoList,
  prevPage,
  filterd,
  guestCount,
  fromUI,
  guestDetails
) {
  let guestSummary = {}
  if (!room || !room.id || room.id === '') return 0
  if (fromUI || (guestDetails && guestDetails.length > 0)) {
    // While populating the form in UI the complete room details will not be populated until the form gets submitted
    // So this logic will get the guest details from guestDetails object
    let guests = []
    if (guestDetails[0].room.value) {
      guests = _.filter(guestDetails, { room: { value: room.id } })
      guestSummary = _(guests)
        .groupBy('guestType.value')
        .mapValues(guests => guests.length)
        .value()
    } else {
      guests = _.filter(guestDetails, { room: room.id })
      guestSummary = _(guests)
        .groupBy('guestType')
        .mapValues(guests => guests.length)
        .value()
    }
    if (!guestSummary.adult) guestSummary.adult = 0
    if (!guestSummary.child) guestSummary.child = 0
  }
  if (guestSummary[undefined]) delete guestSummary[undefined]
  if (isEmpty(guestSummary)) return 0

  let oneRoomSelected = _.find(guestDetails, guest => {
    return !isEmpty(getObjVal(guest.room))
  })
  return validateRoom(
    authenticated,
    room.type,
    guestSummary.adult || 0,
    guestSummary.child || 0,
    guestCount,
    oneRoomSelected,
    fromUI,
    guestDetails
  )
}
export function validateRoom(
  authenticated,
  roomType,
  numAdults = 0,
  numKids = 0,
  guestCount,
  oneRoomSelected,
  fromUI,
  guestDetails
) {
  if (fromUI && numAdults === 0) {
    if (isAdultRequired(roomType)) {
      return 'A ' + roomType + ' room should have at least one adult in it'
    }
  }
}

// Gets the guestInfoList object values
export function getObjValues(guestInfoList) {
  if (guestInfoList instanceof Object) {
    guestInfoList = Object.keys(guestInfoList).map(function(key) {
      return guestInfoList[key]
    })
  }

  if (
    !isEmpty(guestInfoList[0]) &&
    guestInfoList[0].guestType instanceof Object
  ) {
    let guests = guestInfoList.map(guestInfo => {
      guestInfo.guestType = getObjVal(guestInfo.guestType)
      return guestInfo
    })
    return guests
  } else {
    return guestInfoList
  }
}

/**
 * Validates each room of form selection
 */
export function validateRoomsPrice(
  authenticated,
  selections,
  rooms,
  prevPage,
  fromUI,
  guestDetails,
  dispatch
) {
  let validMessages = []
  selections.forEach(selection => {
    selection.rooms.forEach(room => {
      if (getObjVal(room.roomId)) {
        let message = getInvalidRoom(
          authenticated,
          rooms[getObjVal(room.roomId)],
          room.guests,
          prevPage,
          false,
          room.numGuests,
          fromUI,
          guestDetails
        )
        validMessages.push(message)
      }
    })
  })

  return _.without(validMessages, '')
}

export function getPrimaryRoom(selections) {
  let primaryRoomId
  selections.forEach(selection => {
    if (selection.rooms) {
      selection.rooms.forEach(room => {
        if (_.some(room.guests, 'isPrimary')) {
          primaryRoomId = room.roomId
        }
      })
    }
  })
  return primaryRoomId
}

export function getPrimaryGuest(selections) {
  let primaryGuest
  // console.log('---getPrmGst:: Selection ', selections)
  selections.forEach(selection => {
    if (selection.rooms) {
      selection.rooms.forEach(room => {
        let primary = _.find(room.guests, 'isPrimary')
        if (primary) {
          primaryGuest = primary
        }
      })
    }
  })
  return primaryGuest
}

export function getGuestsFromSelections(selections) {
  return _(selections)
    .filter('rooms')
    .flatMap('rooms')
    .flatMap(room => _.slice(room.guests, 0, parseInt(room.numGuests)))
    .value()
}

export function getVisitsForRange(visits, startDate, endDate) {
  let desiredRange = moment.range(startDate, endDate)
  return _.pickBy(visits, visit => {
    let visitRange = moment.range(visit.checkInDate, visit.checkOutDate)
    return visitRange.overlaps(desiredRange)
  })
}
// Gets the Room names list to display in Dropdown
export function getRoomsList(listings, rooms) {
  let roomsList = _.flatMap(listings, (listingField, listingIndex) => {
    return listingField.rooms.map((roomField, roomIndex) => {
      if (roomField.roomId.value) {
        let roomObject = rooms[getObjVal(roomField.roomId.value)]
        if (roomObject) {
          let displayName = getRoomDisplayName(
            roomObject.type,
            roomObject.gender
          )
          return { value: roomObject.id, label: displayName }
        }
      }
    })
  })
  roomsList = _.remove(roomsList, undefined)
  return roomsList
}

/**
 * Sorts room types for showing in search results
 * First sort by availability
 * Then by room type
 * Then by gender
 */
export function sortRooms(rooms) {
  return _.sortBy(rooms, room => {
    let val = [
      room.numAvailable > 0 ? 0 : 1,
      _.indexOf(roomDisplaySortOrder, room.type),
      room.gender === 'male' ? 0 : 1
    ]
    return val
  })
}

// Gets the initial values from localstorage if page is refreshed...
export function getGuestInitFields(defaultPayingGuestValue) {
  let initValues = { payingGuest: defaultPayingGuestValue }
  let fieldsObj = getFieldsFromCache()
  if (fieldsObj) {
    fieldsObj.commonGuestFields = actions.formatCommonGuestFields(
      fieldsObj.commonGuestFields
    )
    initValues['commonGuestFields'] = fieldsObj.commonGuestFields
    fieldsObj.listings = actions.formatListings(fieldsObj.listings)
    initValues['listings'] = fieldsObj.listings
    initValues['payingGuest'] = getObjVal(fieldsObj.payingGuest)
    fieldsObj.guestDetails = actions.formatGuestDetails(fieldsObj.guestDetails)
    initValues['guestDetails'] = fieldsObj.guestDetails
  }
  return initValues
}

// Gets the fields object from localstorage and returns back the parsed object
export function getFieldsFromCache() {
  let fields = localStorage.getItem('fields')
  let fieldsObj
  if (
    (fields != null || fields != undefined) &&
    JSON.parse(fields).listings.length > 0
  ) {
    fieldsObj = JSON.parse(fields)
  }
  return fieldsObj
}

// Gets the given object from localstorage and returns back the parsed object
export function getObjFromCache(objName) {
  let obj = localStorage.getItem(objName)
  if (obj && JSON.parse(obj) && Object.keys(JSON.parse(obj)).length > 0) {
    return JSON.parse(obj)
  }
}

// Clears all localstorage items
export function clearAppCache() {
  localStorage.removeItem('rooms')
  localStorage.removeItem('fields')
  localStorage.removeItem('pricePanel')
}

export function gotoSearchPage(event, location, dispatch) {
  if (event) event.preventDefault()
  let path = location.pathname
  dispatch(dispatch(actions.unlockRooms))
  if (path != '/results') {
    history.push('/results')
  }
  dispatch(actions.stopHoldTimer())
  dispatch(actions.cancelled())
}

export function setGuestFormFieldsToCache(props, selectedRooms) {
  if (props.fields && props.fields.listings.length > 0) {
    localStorage.removeItem('rooms')
    localStorage.removeItem('fields')
    localStorage.removeItem('selectedRooms')

    if (props.fields) {
      localStorage.setItem('fields', JSON.stringify(props.fields))
    }
    if (props.rooms) {
      localStorage.setItem('rooms', JSON.stringify(props.rooms))
    }
    if (selectedRooms) {
      localStorage.setItem('selectedRooms', JSON.stringify(selectedRooms))
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/stateUtils.js